import * as R from 'ramda';

const getRoutes = R.path(['location', 'routesMap']);

export default getRoutes;

